import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { BrandLogo } from "@/brand";
import ThemeToggle from "@/components/landing/ThemeToggle";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 bg-[var(--gm-paper-80)] backdrop-blur-xl border-b transition-colors duration-500 ${
        scrolled ? "border-[var(--gm-line-faint)]" : "border-transparent"
      }`}
      data-testid="main-navbar"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <a href="#inicio" className="flex items-center gap-3" data-testid="nav-logo">
          <BrandLogo />
        </a>
        <nav className="hidden md:flex items-center gap-10 text-sm font-light">
          <a href="#practica" className="hover:text-[var(--gm-accent)] transition-colors duration-300" data-testid="nav-link-practica">Práctica</a>
          <a href="#trayectoria" className="hover:text-[var(--gm-accent)] transition-colors duration-300" data-testid="nav-link-trayectoria">Trayectoria</a>
          <a href="#semblanza" className="hover:text-[var(--gm-accent)] transition-colors duration-300" data-testid="nav-link-semblanza">Semblanza</a>
          <a href="#plataforma" className="hover:text-[var(--gm-accent)] transition-colors duration-300" data-testid="nav-link-plataforma">Plataforma</a>
          <a href="#contacto" className="hover:text-[var(--gm-accent)] transition-colors duration-300" data-testid="nav-link-contacto">Contacto</a>
        </nav>
        <div className="flex items-center gap-4">
          <ThemeToggle />
          <a
            href="#plataforma"
            className="btn-navy px-6 py-2.5 text-sm rounded-full"
            data-testid="nav-portal-login-btn"
          >
            Iniciar sesión
          </a>
        </div>
      </div>
    </motion.header>
  );
};

export default Navbar;
